import { Link } from 'react-router-dom';
import { Mail, Linkedin, Github } from 'lucide-react';

function Footer() {
  return (
    <section className='bg-black'>   
    <footer className="bg-[#161616] text-white py-16 px-4 lg:px-6 rounded-[60px] w-full max-w-[99vw] mx-auto">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {/* Left Column */}
          <div>
            <div className="text-sm mb-6 text-white/40 tracking-wider font-silkscreen">
              STAY CONNECTED
            </div>
            <h4 className="text-xl lg:text-2xl mb-6 font-silkscreen hover:text-orange-500 transition-colors">
              <a href="mailto:bekirhan-simsek@hotmail.com">BEKIRHAN-SIMSEK@HOTMAIL.COM</a>
            </h4>
            <p className="text-white/60 text-sm max-w-md leading-relaxed mb-8">
              Bekirhan Simsek - Full-stack developer and UX enthusiast. Passionate about 
              creating digital experiences that combine creativity with functionality.
            </p>
            <div className="text-white/40 text-xs font-silkscreen">
              Made with ❤️ by Bekirhan Simsek
            </div>
          </div>

          {/* Right Column - Navigation + Social */}
          <div className="grid grid-cols-2 gap-8">
            {/* Navigation Links */}
            <div>
              <div className="space-y-4 text-base lg:text-lg font-silkscreen">
                <Link to="/" className="block hover:text-orange-500 transition-colors">
                  Home
                </Link>
                <Link to="/about" className="block hover:text-orange-500 transition-colors">
                  About
                </Link>
                <Link to="/projects" className="block hover:text-orange-500 transition-colors">
                  Projects
                </Link>
                <Link to="/stage" className="block hover:text-orange-500 transition-colors">
                  Internship
                </Link>
                <Link to="/contact" className="block hover:text-orange-500 transition-colors">
                  Contact
                </Link>
              </div>
            </div>

            {/* Social Media */}
            <div>
              <div className="text-sm mb-4 text-white/40 tracking-wider font-silkscreen">
                SOCIAL MEDIA
              </div>
              <div className="flex gap-4">
                <a
                  href="https://www.linkedin.com/in/bekirhan-simsek-5b675a358/"
                  className="backdrop-blur-xl bg-white/10 hover:bg-orange-500 w-12 h-12 rounded-full flex items-center justify-center transition-all border border-white/20 hover:border-orange-500"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
                <a
                  href="https://github.com/bekirhansimsek"
                  className="backdrop-blur-xl bg-white/10 hover:bg-orange-500 w-12 h-12 rounded-full flex items-center justify-center transition-all border border-white/20 hover:border-orange-500"
                >
                  <Github className="w-5 h-5" />
                </a>
                <a
                  href="mailto:bekirhan-simsek@hotmail.com"
                  className="backdrop-blur-xl bg-white/10 hover:bg-orange-500 w-12 h-12 rounded-full flex items-center justify-center transition-all border border-white/20 hover:border-orange-500"
                >
                  <Mail className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom - Large Branding */}
        <div className="text-center pt-16 border-t border-white/10">
          <div className="text-3xl lg:text-4xl font-bold mb-6 font-silkscreen tracking-wider">
            BEKIRHAN SIMSEK
          </div>
          <div className="text-white/40 text-xs font-silkscreen">
            ©2026 BEKIRHAN Studio. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
    </section>
  );
}

export default Footer;